import React, {
  Fragment,
  FunctionComponent,
  useContext,
  useEffect,
  useState,
} from "react";

import { Theme, createStyles, lighten } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import Tooltip from "@mui/material/Tooltip";
import Container from "@mui/material/Container";
import TableContainer from "@mui/material/TableContainer";
import { Box, Tabs, Tab } from "@mui/material";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import {
  Typography,
  Card,
  CardMedia,
  CardContent,
  CardActions,
  Grid,
} from "@mui/material";

import { WrappedComponentProps } from "../utils/authHelper";
import AuthProvider from "../utils/authProvider";
import { FlowiseProvider } from "../context/FlowiseContext";
import FlowiseBubble from "../components/FlowiseBubble";
type AuthProps = WrappedComponentProps;

import { makeStyles } from "tss-react/mui";
const useStyles = makeStyles()((theme: Theme) => ({
  root: {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "space-around",
    overflow: "hidden",
    "& .MuiTextField-root": {
      margin: theme.spacing(1),
    },
    "& .MuiSwitch-root": {
      margin: theme.spacing(1),
    },
    "& .MuiTypography-root": {
      margin: theme.spacing(1),
    },
  },
  container: {},
  card: {
    padding: "10px",
  },
  table: {
    padding: theme.spacing(2),
    width: "100%",
  },
  diagram: {
    marginTop: 50,
    padding: 30,
  },
  media: {
    height: 0,
    paddingTop: "56.25%", // 16:9
  },
  highlight:
    theme.palette.mode === "light"
      ? {
          color: theme.palette.secondary.main,
          backgroundColor: lighten(theme.palette.secondary.light, 0.85),
        }
      : {
          color: theme.palette.text.primary,
          backgroundColor: theme.palette.secondary.dark,
        },
  title: {
    flex: "1 1 100%",
  },
}));

const appsData = [
  {
    name: "Abfuhrkalender",
    devLink: "https://gsc-r1-de-ase-abfuhrkalender-1.azurewebsites.net/",
    prodLink: "https://abfuhrkalender.genesiscloud.cc/",
    type: "webapp",
    versionInfo: {
      framework: "Node 18",
      reactVersion: "18",
      reactScriptsVersion: "5",
      muiVersion: "5",
      lastUpdate: "2024-04-20",
    },
  },
  {
    name: "Scada Plant",
    devLink: null,
    prodLink: "https://scadaplant-at.genesiscloud.cc/",
    type: "webapp",
    versionInfo: {
      framework: "Node 18",
      reactVersion: "19",
      reactScriptsVersion: "5",
      muiVersion: "7",
      lastUpdate: "2025-20-05",
    },
  },
  {
    name: "Digitale Visitenkarte",
    devLink: null,
    prodLink: "https://me.loacker.cc/",
    type: "webapp",
    versionInfo: {
      framework: "Node 18",
      reactVersion: "17",
      reactScriptsVersion: "5",
      muiVersion: "5",
      lastUpdate: "2025-20-05",
    },
  },
  {
    name: "Material Data",
    devLink: "https://materialdata.genesiscloud.cc",
    prodLink: "https://materialdata.genesiscloud.cc/",
    type: "webapp",
    versionInfo: {
      framework: "Node 14",
      reactVersion: "16",
      reactScriptsVersion: "3",
      muiVersion: "React Bootstrap 4",
      lastUpdate: "2021-31-12",
    },
  },
  {
    name: "Product Data Managment (PDM)",
    devLink: null,
    prodLink: "https://pdm.genesiscloud.cc",
    type: "webapp",
    versionInfo: {
      framework: "Node 14",
      reactVersion: "17",
      reactScriptsVersion: "4",
      muiVersion: "4",
      lastUpdate: "2023-30-06",
    },
  },
  {
    name: "Stammdaten(MDM)",
    devLink: null,
    prodLink: "https://mdm.genesiscloud.cc",
    type: "webapp",
    versionInfo: {
      framework: "Node 14",
      reactVersion: "17",
      reactScriptsVersion: "4",
      muiVersion: "4",
      lastUpdate: "2025-31-02",
    },
  },
  {
    name: "Toolbox-Sandbox",
    devLink: null,
    prodLink: "https://toolbox.genesiscloud.cc/",
    type: "webapp",
    versionInfo: {
      framework: "Node 18",
      reactVersion: "18",
      muiVersion: "5",
      lastUpdate: "2025-20-05",
    },
  },
  // Backends on AZURE
  {
    name: "Central Gateway API Swagger AAD",
    server: "Azure",
    prodLink:
      "https://gsc-r1-pr-ase-centralgateway-1.azurewebsites.net/swagger/index.html",
    type: "backend",
    versionInfo: {
      framework: "ASP.NET Core",
      netVersion: "7.0",
      lastUpdate: "2024-03-10",
    },
  },
  {
    name: "External Gateway API Swagger B2C",
    server: "Azure",
    prodLink:
      "https://gsc-r1-pr-ase-externalcentralgateway-1.azurewebsites.net/swagger/index.html",
    type: "backend",
    versionInfo: {
      framework: "ASP.NET Core",
      netVersion: "7.0",
      lastUpdate: "2024-03-10",
    },
  },
  {
    name: "Material Data API Swagger",
    server: "Azure",
    prodLink:
      "https://gsc-r1-pr-ase-materialdataapi-1.azurewebsites.net/swagger/index.html",
    type: "backend",
    versionInfo: {
      framework: "ASP.NET Core",
      netVersion: "6.0",
      lastUpdate: "2023-12-05",
    },
  },
  {
    name: "News Data API Swagger",
    server: "Azure",
    prodLink:
      "https://gsc-r1-pr-ase-newsapi-1.azurewebsites.net/swagger/index.html",
    type: "backend",
    versionInfo: {
      framework: "ASP.NET Core",
      nodeVersion: "16.0.0",
      lastUpdate: "2024-01-20",
    },
  },
  // Backend on atgolorsdataapi
  {
    name: "ERPDataGateway",
    server: "atgolorsdataapi",
    devLink: "https://datagatewaybackendde.genesiscloud.cc:4443/graphql",
    testLink: "https://datagatewaybackendte.genesiscloud.cc:4444/graphql",
    reLink: "https://datagatewaybackendre.genesiscloud.cc:4446/graphql",
    prodLink: "https://datagatewaybackendpr.genesiscloud.cc:4445/graphql",
    type: "backend",
    versionInfo: {
      framework: "NODE 14",
      lastUpdate: "2025-20-05",
    },
  },
  // Backend on 192.168.66.193
  {
    name: "PROXY",
    server: "192.168.66.193",
    prodLink: "https://erprpx.genesiscloud.cc/login",
    type: "backend",
    versionInfo: {
      framework: "NODE 18",
      lastUpdate: "2025-20-05",
    },
  },
  {
    name: "ERPGW",
    server: "192.168.66.193",
    reLink: "https://erpgwre.genesiscloud.cc/graphql",
    prodLink: "https://erpgwpr.genesiscloud.cc/graphql",
    type: "backend",
    versionInfo: {
      framework: "NODE 18",
      lastUpdate: "2025-20-05",
    },
  },
  {
    name: "Balancer",
    server: "192.168.66.193",
    type: "backend",
    versionInfo: {
      framework: "NODE 18",
      lastUpdate: "2025-20-05",
    },
  },
  // Dev Servers -Gateways
  {
    name: "Recy gateway",
    server: "192.168.66.1",
    prodLink: "http://192.168.66.1:4443/graphql",
    reLink: "http://192.168.66.1:4442/graphql",
    type: "backend",
    versionInfo: {
      framework: "NODE 18",
      lastUpdate: "2025-20-05",
    },
  },
  {
    name: "RONA gateway",
    server: "192.168.66.1",
    prodLink: "http://192.168.66.1:3443/graphql",
    reLink: "http://192.168.66.1:3442/graphql",
    type: "backend",
    versionInfo: {
      framework: "NODE 18",
      lastUpdate: "2025-20-05",
    },
  },
  {
    name: "Telltex gateway",
    server: "192.168.66.1",
    prodLink: "http://192.168.66.1:2443/graphql",
    reLink: "http://192.168.66.1:2442/graphql",
    type: "backend",
    versionInfo: {
      framework: "NODE 18",
      lastUpdate: "2025-20-05",
    },
  },
];

// Nueva data para Admin Apps
const adminAppsData = [
  { name: "Portainer", link: "https://portainer.genesiscloud.cc/#!/home" },
  { name: "PM2", link: "https://app.pm2.io/" },
  { name: "Reverse Proxy", link: "https://erprpx.genesiscloud.cc/nginx/proxy" },
  { name: "Vault", link: "https://vault.genesiscloud.cc/#/" },
  {
    name: "Grafana",
    link: "http://192.168.66.206:3000/d/3954513a-3570-4a24-97a9-16eeb80e894c/dev-servers?orgId=1&from=now%2Fd&to=now&timezone=browser&refresh=10s",
  },
  { name: "Prometheus", link: "http://192.168.66.206:9090/targets" },
  {
    name: "Blackbox exporter",
    link: "http://192.168.66.206:9115/probe?module=http_2xx&target=https://google.com",
  },
  { name: "Node exporter", link: "http://192.168.66.206:9100/metrics" },
  {
    name: "QDrant Prod",
    link: "http://192.168.66.21:6333/dashboard#/collections",
  },
  { name: "Redis Insights", link: "http://192.168.66.21:5540" },
  { name: "Flowwise", link: "https://flow.genesiscloud.cc" },
  { name: "Langfuse", link: "https://langf.genesiscloud.cc" },
  { name: "docling serve", link: "http://192.168.66.31:5001/ui/" },
  { name: "DevOps", link: "https://dev.azure.com/GenesisCloudApps1/" },
  {
    name: "Azure Portal",
    link: "https://portal.azure.com/#@genesiscloud.onmicrosoft.com/dashboard/arm/subscriptions/1e24f37d-1083-48ea-827b-0e5dea4461cb/resourcegroups/dashboards/providers/microsoft.portal/dashboards/2cd446d0-5ac4-40d5-bce0-2b5aeff5305f",
  },
];

// Nueva data para External Links
const externalLinksData = [
  {
    name: "RECY ONLINE API - DEV",
    link: "http://80.120.126.203:4453/RecyOnline.API/api-docs/index.html",
  },
  {
    name: "RECY Import / Export - DEV",
    link: "http://80.120.126.203:4453/bulk-import-export/api-docs/index.html",
  },
  {
    name: "RECY businessprocesses - DEV",
    link: "http://80.120.126.203:4453/businessprocesses/api-docs/index.html",
  },
  {
    name: "RONA API",
    link: "https://rona.loacker.cc:48003/ContecMobile/?wsdl",
  },
  { name: "KENDOX", link: "http://ATGOLOS220/InfoShare" },
  {
    name: "Kunden Portal Dev",
    link: "https://loacker-kundenportal.denovo.cloud/portal/container-overview",
  },
  { name: "Kunden Portal", link: "https://kundenportal.loacker.cc/login" },
  {
    name: "Mongo DB",
    link: "https://cloud.mongodb.com/v2/5f9bd7bca5436a13f75b2c3a#clusters",
  },
  {
    name: "WIKI - on 192.168.66.206",
    link: "https://wiki.genesiscloud.cc/de/home",
  },
  {
    name: "Adino",
    link: "https://srv280.adino.at:8443/login_up.php?success_redirect_url=%2Fsmb%2Fweb%2Fview",
  },
  { name: "Slock Sensors", link: "https://swc.sloc.one/login" },
  { name: "Infeo", link: "https://awm.infeo.at/de/login" },
  { name: "Wordpress Loacker", link: "https://loacker-recycling.com/at/" },
];

// Función auxiliar para renderizar la información de la versión
const renderVersionInfo = (versionInfo: any) => {
  if (!versionInfo) return "-";
  const details = [];
  for (const key in versionInfo) {
    if (versionInfo.hasOwnProperty(key)) {
      details.push(`${key}: ${versionInfo[key]}`);
    }
  }
  return (
    <Tooltip title={details.join("\n")} placement="right" arrow>
      <span>{versionInfo.framework}</span>
    </Tooltip>
  );
};

// Renderizado de tabla para Admin Apps
const renderAdminAppsTable = (data: any) => (
  <Paper elevation={4} sx={{ borderRadius: 3, boxShadow: 6, mb: 3, p: 2 }}>
    <TableContainer>
      <Table stickyHeader aria-label="admin apps table">
        <TableHead>
          <TableRow
            sx={{ backgroundColor: (theme) => theme.palette.primary.main }}
          >
            <TableCell
              sx={{ color: "white", fontWeight: "bold", fontSize: 16 }}
            >
              APP
            </TableCell>
            <TableCell
              sx={{ color: "white", fontWeight: "bold", fontSize: 16 }}
            >
              Link
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {data.map((app: any, index: number) => (
            <TableRow
              hover
              key={index}
              sx={{
                backgroundColor:
                  index % 2 === 0 ? "background.paper" : "grey.100",
                transition: "background 0.3s",
                "&:hover": { backgroundColor: "primary.light", color: "white" },
              }}
            >
              <TableCell sx={{ fontWeight: 500, fontSize: 15 }}>
                {app.name}
              </TableCell>
              <TableCell>
                <a href={app.link} target="_blank" rel="noopener noreferrer">
                  <OpenInNewIcon color="primary" />
                </a>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  </Paper>
);

// Renderizado de tabla para External Links
export const renderExternalLinksTable = (data: any) => (
  <Paper elevation={4} sx={{ borderRadius: 3, boxShadow: 6, mb: 3, p: 2 }}>
    <TableContainer>
      <Table stickyHeader aria-label="external links table">
        <TableHead>
          <TableRow
            sx={{ backgroundColor: (theme) => theme.palette.primary.main }}
          >
            <TableCell
              sx={{ color: "white", fontWeight: "bold", fontSize: 16 }}
            >
              APP
            </TableCell>
            <TableCell
              sx={{ color: "white", fontWeight: "bold", fontSize: 16 }}
            >
              Link
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {data.map((app: any, index: number) => (
            <TableRow
              hover
              key={index}
              sx={{
                backgroundColor:
                  index % 2 === 0 ? "background.paper" : "grey.100",
                transition: "background 0.3s",
                "&:hover": { backgroundColor: "primary.light", color: "white" },
              }}
            >
              <TableCell sx={{ fontWeight: 500, fontSize: 15 }}>
                {app.name}
              </TableCell>
              <TableCell>
                <a href={app.link} target="_blank" rel="noopener noreferrer">
                  <OpenInNewIcon color="primary" />
                </a>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  </Paper>
);

interface IEventsPageProps {}

const renderTable = (data: any, colSpanHeaders: any) => (
  <TableContainer>
    <Table stickyHeader aria-label="sticky table">
      <TableHead>
        <TableRow>
          <TableCell>APP</TableCell>
          <TableCell>DEV</TableCell>
          <TableCell>TEST</TableCell>
          <TableCell>RE</TableCell>
          <TableCell>PROD</TableCell>
          <TableCell>Versión</TableCell>{" "}
          {/* Esta columna se mantiene en todas las tablas */}
        </TableRow>
      </TableHead>
      <TableBody>
        {data.map((app: any, index: any) => (
          <TableRow hover key={index}>
            <TableCell>
              <span>{app.name}</span>
            </TableCell>
            <TableCell>
              {app.devLink ? (
                <a href={app.devLink} target="_blank" rel="noopener noreferrer">
                  <OpenInNewIcon />
                </a>
              ) : (
                "-"
              )}
            </TableCell>
            <TableCell>
              {app.testLink ? (
                <a
                  href={app.testLink}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <OpenInNewIcon />
                </a>
              ) : (
                "-"
              )}
            </TableCell>
            <TableCell>
              {app.reLink ? (
                <a href={app.reLink} target="_blank" rel="noopener noreferrer">
                  <OpenInNewIcon />
                </a>
              ) : (
                "-"
              )}
            </TableCell>
            <TableCell>
              {app.prodLink ? (
                <a
                  href={app.prodLink}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <OpenInNewIcon />
                </a>
              ) : (
                "-"
              )}
            </TableCell>
            <TableCell>{renderVersionInfo(app.versionInfo)}</TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  </TableContainer>
);

// Componente auxiliar para los paneles de pestañas
function TabPanel(props: any) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      style={{ minHeight: 500, transition: "min-height 0.3s" }} // altura fija y transición suave
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

// Función auxiliar para las props de accesibilidad de las pestañas
function a11yProps(index: any) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export const CatalogPage: FunctionComponent<IEventsPageProps> = (props) => {
  const { classes } = useStyles();

  const [value, setValue] = useState(0); // Estado para controlar la pestaña activa

  const handleChange = (event: any, newValue: any) => {
    setValue(newValue);
  };

  return (
    <Fragment>
      <Box sx={{ mb: 4 }}>
        <Paper
          elevation={6}
          sx={{
            borderRadius: 4,
            p: 3,
            background: (theme) => theme.palette.primary.main,
            boxShadow: 8,
          }}
        >
          <Typography
            variant="h3"
            align="center"
            sx={{ color: "white", fontWeight: 700, letterSpacing: 1, mb: 0 }}
          >
            Applications Catalog 👷
          </Typography>
        </Paper>
      </Box>
      <Box sx={{ display: "flex", justifyContent: "center", width: "100%" }}>
        <Paper
          elevation={4}
          sx={{
            maxWidth: 1200,
            width: "100%",
            mx: "auto",
            p: 4,
            borderRadius: 0,
            boxShadow: 0,
          }}
        >
          <Grid container direction="row" spacing={2} justifyContent="center">
            <Grid item xs={12}>
              <Box sx={{ width: "100%" }}>
                <Box sx={{ borderBottom: 1, borderColor: "divider", mb: 2 }}>
                  <Tabs
                    value={value}
                    onChange={handleChange}
                    aria-label="basic tabs example"
                    variant="scrollable"
                    scrollButtons="auto"
                    sx={{
                      background: (theme) => theme.palette.background.paper,
                      borderRadius: 3,
                      boxShadow: 2,
                      minHeight: 48,
                      "& .MuiTab-root": {
                        fontWeight: 600,
                        fontSize: 16,
                        borderRadius: 2,
                        mx: 0.5,
                        minHeight: 48,
                        color: "primary.main",
                      },
                      "& .Mui-selected": {
                        background: (theme) => theme.palette.primary.main,
                        color: "white !important",
                      },
                      "& .MuiTabs-indicator": {
                        backgroundColor: "primary.main",
                        height: 4,
                        borderRadius: 2,
                      },
                    }}
                  >
                    <Tab label="Webapps on AZURE" {...a11yProps(0)} />
                    <Tab label="Backends on AZURE" {...a11yProps(1)} />
                    <Tab label="Backends atgolorsdataapi" {...a11yProps(2)} />
                    <Tab label="Backends 192.168.66.193" {...a11yProps(3)} />
                    <Tab label="Dev Servers - Gateways" {...a11yProps(4)} />
                  </Tabs>
                </Box>
                <TabPanel value={value} index={0}>
                  <Typography
                    variant="h6"
                    component="h2"
                    color="secondary"
                    gutterBottom
                  >
                    Webapps on AZURE
                  </Typography>
                  {renderTable(
                    appsData.filter((app) => app.type === "webapp"),
                    6,
                  )}
                </TabPanel>
                <TabPanel value={value} index={1}>
                  <Typography
                    variant="h6"
                    component="h2"
                    color="secondary"
                    gutterBottom
                  >
                    Backends on AZURE
                  </Typography>
                  {renderTable(
                    appsData.filter(
                      (app) => app.type === "backend" && app.server === "Azure",
                    ),
                    6,
                  )}
                </TabPanel>
                <TabPanel value={value} index={2}>
                  <Typography
                    variant="h6"
                    component="h2"
                    color="secondary"
                    gutterBottom
                  >
                    Backends on atgolorsdataapi 🚀
                  </Typography>
                  {renderTable(
                    appsData.filter(
                      (app) =>
                        app.type === "backend" &&
                        app.server === "atgolorsdataapi",
                    ),
                    6,
                  )}
                </TabPanel>
                <TabPanel value={value} index={3}>
                  <Typography
                    variant="h6"
                    component="h2"
                    color="secondary"
                    gutterBottom
                  >
                    Backends on 192.168.66.193
                  </Typography>
                  {renderTable(
                    appsData.filter(
                      (app) =>
                        app.type === "backend" &&
                        app.server === "192.168.66.193",
                    ),
                    6,
                  )}
                </TabPanel>
                <TabPanel value={value} index={4}>
                  <Typography
                    variant="h6"
                    component="h2"
                    color="secondary"
                    gutterBottom
                  >
                    Dev Servers - Gateways
                  </Typography>
                  {renderTable(
                    appsData.filter(
                      (app) =>
                        app.type === "backend" && app.server === "192.168.66.1",
                    ),
                    6,
                  )}
                </TabPanel>
              </Box>
            </Grid>
            <Grid item xs={12} md={6}>
              <Box sx={{ mt: 4 }}>
                <Typography
                  variant="h6"
                  component="h2"
                  color="secondary"
                  gutterBottom
                >
                  Admin Apps
                </Typography>
                {renderAdminAppsTable(adminAppsData)}
              </Box>
            </Grid>
            <Grid item xs={12} md={6}>
              <Box sx={{ mt: 4 }}>
                <Typography
                  variant="h6"
                  component="h2"
                  color="secondary"
                  gutterBottom
                >
                  External Links
                </Typography>
                {renderExternalLinksTable(externalLinksData)}
              </Box>
            </Grid>
          </Grid>
        </Paper>
      </Box>
      <FlowiseProvider>
        <FlowiseBubble />
      </FlowiseProvider>
    </Fragment>
  );
};
